import { createElement } from 'react';

import IconDeepResearchText from '@components/Images/DeepResearch/IconDeepResearchText';

import { BenefitProps } from './interfaces';

// `eligibility` is a boolean array specifying checkbox status,
// visible === true, for either Annual or Pro subscription types,
// in this case

export const AUDIO_ARTICLES = 'Audio articles';
export const MONTHLY_SWITCH_BENEFITS_TO_ANNUAL = [
  {
    name: 'Exclusive content',
    eligibility: [false, true],
    tooltip: 'Access to content published for annual subscribers only',
  },
  {
    name: 'Full article share',
    eligibility: [false, true],
    tooltip: 'Share any article with 3 new contacts',
  },
  {
    name: AUDIO_ARTICLES,
    eligibility: [false, true],
    tooltip: 'Listen to any article in audio format',
  },
  {
    name: 'In-depth reporting',
    eligibility: [true, true],
  },
  {
    name: '10+ topic-specific newsletters',
    eligibility: [true, true],
  },
  {
    name: 'Live video events',
    eligibility: [true, true],
  },
  {
    name: 'Subscriber community',
    eligibility: [true, true],
  },
];
export const BENEFITS: BenefitProps[] = [
  {
    name: createElement(IconDeepResearchText, { className: 'deep-research-logo' }),
    eligibility: [false, true],
  },
  {
    name: 'Industry-specific org charts',
    eligibility: [false, true],
    tooltip:
      '60+ org charts with reporting lines for over 3,000 executives and directors, from Amazon to Meta.',
  },
  {
    name: 'Proprietary databases',
    eligibility: [false, true],
    tooltip: 'Exclusive, unreported insights into startup funding, investors, and more.',
  },
  {
    name: 'IPO tracker',
    eligibility: [false, true],
    tooltip: 'Track startups on the verge of going public and performance of recent IPOs.',
  },
  {
    name: 'Exclusive live events',
    eligibility: [false, true],
    tooltip:
      'Connect with industry experts through exclusive live events, often with complimentary access for Pro subscribers.',
  },
  {
    name: 'Subscriber surveys',
    eligibility: [false, true],
    tooltip:
      'Explore subscriber sentiment on today’s most relevant topics with our transparent industry surveys.',
  },
  {
    name: AUDIO_ARTICLES,
    eligibility: [true, true],
    tooltip: 'Listen to any article in audio format',
  },
  { name: 'In-depth exclusives', eligibility: [true, true] },
  { name: 'Informative newsletters', eligibility: [true, true] },
  { name: 'Exclusive subscriber network', eligibility: [true, true] },
];

export enum CurrentSubscription {
  Annual = 'annual',
  Monthly = 'monthly',
}

export const MARKETING_COPY = {
  [CurrentSubscription.Annual]: {
    intro:
      'You gain access to all of industry-specific org charts, our proprietary data tool including custom databases offering unreported insights into startup funding, investors, and more. Stay informed with exclusive insights, helping you make better decisions and stay competitive in your industry.',
  },
  [CurrentSubscription.Monthly]: {
    intro:
      'Elevate your reading experience and unlock exclusive insights and stay ahead of the curve with the tech, finance, and business leaders who rely on The Information daily.',
  },
};

export const MONTHLY_SWITCH_BENEFITS = [
  'In-depth exclusives',
  '10+ Topic-specific newsletters',
  'Live video events',
  'Exclusive subscriber network',
];

export const ANNUALIZED_RATE = 'Annualized rate';
export const ANNUALLY = 'Annually';
export const ANNUAL_OFFER_PARAM = 'annual_offer';
export const BEST_VALUE = 'Best Value';
export const EACH_PLAN = 'each plan';
export const EVERY_4_WEEKS = 'Every 4 weeks';
export const MAX_MONTHLY_PRICE = 50;
export const MONTHLY = 'Monthly';
export const PER_MONTH = '/ Month';
export const PER_YEAR = '/ Year';
export const PRO = 'pro';
export const PRO_OFFER_PARAM = 'offer';
export const SPECIAL_OFFER = 'Special Offer';
export const SWITCH = 'Switch';
export const SWITCH_TODAY = `${SWITCH} today`;
export const THE_INFORMATION_PRO = 'The Information Pro';
export const UPGRADE = 'Upgrade';
export const UPGRADE_TODAY = `${UPGRADE} today`;
export const YEARLY = 'yearly';
export const YOUR_SUBSCRIPTION = 'Your Subscription';
export const ZERO_DOLLARS = '$0';

export const MAX_MOBILE_VISIBLE_OFFERS = 2;
